import { Accordion, Box, Button, ButtonsGroup, Card, Grid, InputText, Typo } from "#/atoms";
import { DESKTOP_SPACING, HPOSITION } from "@/theme";
import { FC, memo } from "react";

import { HeadingIcon } from "@/components/molecules";
import { ShareOrderCardProps } from "./ShareOrder.interface";
import { useInput } from "@/hooks";

const ShareOrderCard: FC<ShareOrderCardProps> = ({
  accordionState = 'open',
  onShareOrder,
  orderId
}) => {
   const email = useInput();
   const url = `https://test.choose.photos/#/order-view-shared/order=${orderId}`;

  return (
    <Card>
      <Accordion
        header={<HeadingIcon icon="share" title="Share Photos" />}
        showArrow
        state={accordionState}
      >
        <Typo margin="15px 0px">Send a link to an email address where the recipient can choose edited and outtake photos</Typo>
        <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="40%  40% 15%" margin="10px">
        <InputText
            type="email"
            label="Email"
            value={email?.value}
            onChange={email?.onChange}
          />
          <InputText
              fullWidth={false}
              label="link"
              type="url"
              readOnly={true}
              value={url}
            />
          <Box width="100px" padding="17px 0 0">
            <Button onClick={() => navigator.clipboard.writeText(url)}>Copy</Button>
          </Box>

        </Grid>
        <ButtonsGroup align={HPOSITION.RIGHT} fullWidth>
            <Button onClick={() => onShareOrder(email.value)}>
            Share
            </Button>
        </ButtonsGroup>
      </Accordion>
    </Card>
  );
};

export default memo(ShareOrderCard);